import {toast} from 'react-toastify';

export const showErrorMessage = (errorMessage: string) =>
  toast.error(errorMessage || 'Unknown Error. Contact Engineering!');
